export const capitalizeFirstLetter = (text: string): string =>
  text.length ? text.charAt(0).toUpperCase() + text.toLowerCase().slice(1) : text;

export const getMaskedString = (text: string, replaceWith = '\u2022') =>
  text.replace(/\*/g, replaceWith);
